var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "grid" } },
    [
      _c(
        "button",
        {
          staticClass: "btn-outline btn-tertiary",
          on: {
            click: function ($event) {
              return _vm.openModal()
            },
          },
        },
        [
          _c("i", { staticClass: "fa-light fa-arrow-up-from-bracket" }),
          _vm._v("Import CSV"),
        ]
      ),
      _vm._v(" "),
      _vm.isAlertOpen
        ? _c("alert-modal", [
            _c("span", [
              _c("i", { staticClass: "fa-solid fa-circle-check" }),
              _vm._v(
                "Bulk allocation complete: : " +
                  _vm._s(this.countCreated) +
                  " new, " +
                  _vm._s(this.countExisting) +
                  " existing"
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isModalOpen
        ? _c("div", { staticClass: "modal-container" }, [
            _c("div", { staticClass: "modal-content" }, [
              _c("h1", [
                _vm._v("Bulk Import Orders"),
                _c("i", {
                  staticClass: "fa-regular fa-xmark",
                  on: {
                    click: function ($event) {
                      return _vm.closeModal()
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticStyle: { "font-weight": "normal", color: "#717182" } },
                [
                  _vm._v(
                    "Download the CSV template, fill it with order data, and upload to import multiple orders at once."
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "information-container" }, [
                _c("i", { staticClass: "fa-regular fa-file-lines" }),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "download-btn btn btn-outline",
                    on: { click: _vm.exportCSVTemplate },
                  },
                  [
                    _c("i", {
                      staticClass: "fa-regular fa-arrow-down-to-bracket",
                    }),
                    _vm._v("Download Template"),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.orders.length == 0
                ? _c(
                    "div",
                    {
                      staticClass: "drop-zone",
                      class: { hover: _vm.isDragOver },
                      on: {
                        dragover: function ($event) {
                          $event.preventDefault()
                        },
                        dragenter: function ($event) {
                          $event.preventDefault()
                          _vm.isDragOver = true
                        },
                        dragleave: function ($event) {
                          $event.preventDefault()
                          _vm.isDragOver = false
                        },
                        drop: function ($event) {
                          $event.preventDefault()
                          return _vm.onDrop.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa-regular fa-arrow-up-from-bracket",
                      }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          "Drag and drop your CSV file here, or click to browse"
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v("Supports CSV files with order data"),
                      ]),
                      _vm._v(" "),
                      _c("div", [
                        _c(
                          "button",
                          {
                            staticClass: "btn-outline btn-dark",
                            attrs: { type: "file" },
                            on: { click: _vm.importCSVFile },
                          },
                          [
                            _c("i", {
                              staticClass:
                                "fa-regular fa-arrow-up-from-bracket",
                            }),
                            _vm._v(" Select CSV file"),
                          ]
                        ),
                      ]),
                    ]
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "space-between",
                            "align-items": "center",
                            "font-size": "1.25rem",
                            "font-weight": "bold",
                            color: "black",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "Preview (" +
                                _vm._s(_vm.orders.length) +
                                " orders)"
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticStyle: { display: "flex", gap: "1rem" } },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "btn-outline button-primary btn-outline-light btn",
                                  style: {
                                    cursor: "default",
                                    "pointer-events": "none",
                                    "background-color":
                                      _vm.orders.length > 0
                                        ? "#f0fdf4"
                                        : "white",
                                    color:
                                      _vm.orders.length > 0 ? "#008236" : "",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.orders.length) + " valid")]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "btn-outline-light btn",
                                  on: {
                                    click: function ($event) {
                                      _vm.orders = []
                                    },
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-xmark",
                                  }),
                                  _vm._v(" Clear"),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("b-table", {
                        staticClass: "table-header-border",
                        staticStyle: {
                          "margin-bottom": "0",
                          "margin-top": "2rem",
                        },
                        attrs: {
                          responsive: "",
                          items: _vm.orders,
                          fields: _vm.fields,
                          "primary-key": "id",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "head(index)",
                              fn: function () {
                                return [_c("span", [_vm._v("#")])]
                              },
                              proxy: true,
                            },
                            {
                              key: "cell(index)",
                              fn: function (data) {
                                return [
                                  _c("span", [_vm._v(_vm._s(data.index + 1))]),
                                ]
                              },
                            },
                            {
                              key: "cell(status)",
                              fn: function (data) {
                                return [
                                  data.item.amount == null ||
                                  data.item.amount.trim() == ""
                                    ? _c("i", {
                                        staticClass:
                                          "fa-regular fa-circle-exclamation",
                                        staticStyle: { color: "#d4183d" },
                                      })
                                    : _c("i", {
                                        staticClass:
                                          "fa-regular fa-circle-check",
                                        staticStyle: { color: "#00a63e" },
                                      }),
                                ]
                              },
                            },
                            {
                              key: "cell(clientnumber)",
                              fn: function (data) {
                                return [
                                  data.item.clientNumber != ""
                                    ? _c("span", [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              !_vm.checkAllocationClient(
                                                data.item.clientNumber
                                              )
                                                ? _vm.generateClientNumber()
                                                : data.item.clientNumber
                                            ) +
                                            "\n          "
                                        ),
                                      ])
                                    : _c(
                                        "span",
                                        { staticStyle: { color: "#155dfc" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.generateClientNumber())
                                          ),
                                        ]
                                      ),
                                ]
                              },
                            },
                            {
                              key: "cell(amount)",
                              fn: function (data) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "\n            €" +
                                        _vm._s(data.item.amount) +
                                        "\n          "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(date)",
                              fn: function (data) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(data.item.date) +
                                        "\n          "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(duedate)",
                              fn: function (data) {
                                return [
                                  _c("span", { staticClass: "btn-empty" }, [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(data.item.dueDate) +
                                        "\n          "
                                    ),
                                  ]),
                                ]
                              },
                            },
                            {
                              key: "cell(reference)",
                              fn: function (data) {
                                return [
                                  data.item.reference != ""
                                    ? _c("span", [
                                        _vm._v(
                                          "\n            " +
                                            _vm._s(
                                              !_vm.checkAllocation(
                                                data.item.reference
                                              )
                                                ? _vm.generateReference()
                                                : data.item.reference
                                            ) +
                                            "\n          "
                                        ),
                                      ])
                                    : _c(
                                        "span",
                                        { staticStyle: { color: "#155dfc" } },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.generateReference())
                                          ),
                                        ]
                                      ),
                                ]
                              },
                            },
                            {
                              key: "cell(email)",
                              fn: function (data) {
                                return [
                                  data.item.email != null &&
                                  data.item.email.trim() != ""
                                    ? _c("span", [
                                        _vm._v(_vm._s(data.item.email)),
                                      ])
                                    : _c("span", [_vm._v("—")]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          643063170
                        ),
                      }),
                      _vm._v(" "),
                      _c("hr"),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "justify-content": "end",
                            "align-items": "center",
                            gap: "1rem",
                          },
                        },
                        [
                          _c(
                            "button",
                            {
                              staticClass: "btn-outline-light btn",
                              on: { click: _vm.closeModal },
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _vm.orders.length > 0
                            ? _c(
                                "button",
                                {
                                  staticClass: "btn-outline btn-dark",
                                  staticStyle: {
                                    "background-color": "rgb(21, 93, 252)",
                                    border: "none",
                                  },
                                  on: { click: _vm.submit },
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fa-regular fa-arrow-up-from-bracket",
                                  }),
                                  _vm._v(
                                    "Import " +
                                      _vm._s(_vm.orders.length) +
                                      " Orders"
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ],
                    1
                  ),
            ]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", [_vm._v("CSV Template")]),
      _vm._v(" "),
      _c("span", [
        _vm._v("Download template with sample data and required columns"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }